import React, { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";

import Paper from "@mui/material/Paper";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Accordion from "@mui/material/Accordion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

import LoadingSpinner from "shared/components/UIElements/LoadingSpinner";

import { useHttpClient } from "shared/hooks/http-hook";
import { StoreContext } from "shared/context/store-context";

import { CURRENT_EDUCATION_YEAR_ID } from "@routebot/constants";

const FuelReports = () => {
  const { t } = useTranslation();
  const store = useContext(StoreContext);
  //const [educationYear, setEducationYear] = useState(CURRENT_EDUCATION_YEAR_ID);
  const educationYear = CURRENT_EDUCATION_YEAR_ID;

  const [reportCreated, setReportCreated] = useState(false);

  const [totalFuels, setTotalFuels] = useState([]);
  const [totalVehicleFuels, setTotalVehicleFuels] = useState([]);

  const { isLoading } = useHttpClient();

  const months = [
    {
      label: "Ocak",
      value: "1",
    },
    {
      label: "Şubat",
      value: "2",
    },
    {
      label: "Mart",
      value: "3",
    },
    {
      label: "Nisan",
      value: "4",
    },
    {
      label: "Mayıs",
      value: "5",
    },
    {
      label: "Haziran",
      value: "6",
    },
    {
      label: "Temmuz",
      value: "7",
    },
    {
      label: "Ağustos",
      value: "8",
    },
    {
      label: "Eylül",
      value: "9",
    },
    {
      label: "Ekim",
      value: "10",
    },
    {
      label: "Kasım",
      value: "11",
    },
    {
      label: "Aralık",
      value: "12",
    },
  ];

  useEffect(() => {
    const allFuels = store.fuels;

    let allVehicles = allFuels.map((fuel) => {
      const vehicleId = fuel.vehicle.toString();
      const vehicle = store.vehicles.find((v) => v.id.toString() === vehicleId);
      return {
        key: vehicleId,
        name: vehicle?.plate || t("inventoryReport.unknownVehicle"),
        monthlyFuels: Array.from({ length: 12 }, (_, i) => ({ name: months[i].label, Total: 0 })),
      };
    });

    allVehicles = allVehicles.filter((value, index, self) => index === self.findIndex((t) => t.key === value.key));

    let tempMonthlyFuels = [
      {
        name: "Ocak",
        Total: 0,
      },
      {
        name: "Şubat",
        Total: 0,
      },
      {
        name: "Mart",
        Total: 0,
      },
      {
        name: "Nisan",
        Total: 0,
      },
      {
        name: "Mayıs",
        Total: 0,
      },
      {
        name: "Haziran",
        Total: 0,
      },
      {
        name: "Temmuz",
        Total: 0,
      },
      {
        name: "Ağustos",
        Total: 0,
      },
      {
        name: "Eylül",
        Total: 0,
      },
      {
        name: "Ekim",
        Total: 0,
      },
      {
        name: "Kasım",
        Total: 0,
      },
      {
        name: "Aralık",
        Total: 0,
      },
    ];

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();

    allFuels.forEach((fuel) => {
      const [year, month] = fuel.date.split("-").map(Number);
      if (month === currentMonth && year === currentYear) {
        tempMonthlyFuels[month - 1].Total += parseFloat(fuel.amount);
      }

      const vehicleId = fuel.vehicle.toString();

      allVehicles.find((v) => v.key === vehicleId).monthlyFuels[month - 1].Total += parseFloat(fuel.amount);
    });

    allVehicles.sort((a, b) => a.name.localeCompare(b.name));

    setTotalFuels(tempMonthlyFuels);
    setTotalVehicleFuels(allVehicles);

    setReportCreated(true);
  }, [
    store.receipts,
    store.expenses,
    store.withdraws,
    store.schoolOptions,
    store.contracts,
    store.students,
    educationYear,
  ]);

  if (isLoading) {
    return (
      <div className="center">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <React.Fragment>
      <div style={{ width: "300px", zIndex: "99", position: "relative" }}>
        {/* <CustomSelect
          options={months}
          id="month"
          onInput={(id, value) => selectedMonthChangeHandler(id, value)}
          label=""
          initialValid={true}
          initialValue={months.find((month) => month.value === new Date().getMonth() + 1)}
        ></CustomSelect> */}
      </div>
      {reportCreated && (
        <div>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <h4 style={{ marginLeft: "20px", marginBottom: "0" }}>{t("inventoryReport.monthlyTotalFuelExpenses")}</h4>
            </AccordionSummary>
            <AccordionDetails>
              <TableContainer component={Paper} sx={{ minWidth: 650, width: "inherit" }}>
                <Table
                  sx={{ minWidth: 650, width: "100%", justifyContent: "center", margin: "auto" }}
                  stickyHeader
                  aria-label="simple table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <strong>{t("inventoryReport.month")}</strong>
                      </TableCell>
                      <TableCell>
                        <strong>{t("inventoryReport.totalFuel")}</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {months.map((month) => {
                      const currentMonthFuel = totalFuels.find((fuel) => fuel.name === month.label);

                      return (
                        <TableRow key={month.value} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                          <TableCell component="th" scope="row">
                            {t(`inventoryReport.months.${month.value}`)}
                          </TableCell>
                          <TableCell>{currentMonthFuel ? currentMonthFuel.Total.toLocaleString() : 0}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>

          <br />
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <h4 style={{ marginLeft: "20px", marginBottom: "0" }}>{t("inventoryReport.vehicleBasedFuelExpenses")}</h4>
            </AccordionSummary>
            <AccordionDetails>
              <TableContainer component={Paper} sx={{ minWidth: 650, width: "inherit" }}>
                <Table
                  sx={{ minWidth: 650, width: "100%", justifyContent: "center", margin: "auto" }}
                  stickyHeader
                  aria-label="simple table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <strong>{t("inventoryReport.vehicle")}</strong>
                      </TableCell>
                      <TableCell>
                        <strong>{t("inventoryReport.monthUpper")}</strong>
                      </TableCell>
                      <TableCell>
                        <strong>{t("inventoryReport.totalFuelUpper")}</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {totalVehicleFuels.map((vehicle) => {
                      return vehicle.monthlyFuels.map((month, index) => {
                        return (
                          <TableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                            <TableCell component="th" scope="row">
                              {vehicle.name}
                            </TableCell>
                            <TableCell>{t(`inventoryReport.months.${index + 1}`)}</TableCell>
                            <TableCell>{month.Total.toLocaleString()}</TableCell>
                          </TableRow>
                        );
                      });
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>

          <br />
        </div>
      )}
    </React.Fragment>
  );
};

export default FuelReports;
